import {
    DASHBOARD_PANEL_DELETE_REQUEST,
    DASHBOARD_PANEL_DELETE_RESULT,
    DASHBOARD_PANEL_DELETE_OPEN_MODAL,
} from 'Redux/actionTypes';

export const dashboardPanelDeleteOpenModal = (open, data) => ({
    type: DASHBOARD_PANEL_DELETE_OPEN_MODAL,
    payload: { open, data }
})

export const dashboardPanelDeleteRequest = (data) => ({
    type: DASHBOARD_PANEL_DELETE_REQUEST,
    payload: { data }
})

export const dashboardPanelDeleteResult = (data) => ({
    type: DASHBOARD_PANEL_DELETE_RESULT,
    payload: { data }
})